import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { CreatePostInput } from '@/api/endpoints'
import { postsApi } from '@/api/endpoints'
import { keys } from '@/api/keys'
import type { Post } from '@/api/types'
import { patchPostEverywhere, prependPostToTimeline } from '@/lib/cache'

export function useCreatePost() {
  const client = useQueryClient()

  return useMutation({
    mutationFn: (input: CreatePostInput) => postsApi.create(input),

    onSuccess: (post: Post, input) => {
      if (input.reply_to_id) {
        // 父帖回复数 +1，并让回复列表重新取
        patchPostEverywhere(client, input.reply_to_id, (parent) => ({
          ...parent,
          counts: { ...parent.counts, replies: parent.counts.replies + 1 },
        }))
        client.invalidateQueries({ queryKey: keys.postReplies(input.reply_to_id) })
      } else {
        // 新帖插到主页时间线顶部，不重新拉取（避免列表跳动）
        prependPostToTimeline(client, keys.timelineHome(), post)
      }

      if (input.quote_of_id) {
        patchPostEverywhere(client, input.quote_of_id, (quoted) => ({
          ...quoted,
          counts: { ...quoted.counts, quotes: quoted.counts.quotes + 1 },
        }))
      }

      // 用户页的各个 tab 需要重新取
      client.invalidateQueries({ queryKey: ['timeline', 'user', post.author.username] })
      client.invalidateQueries({ queryKey: keys.user(post.author.username) })
    },
  })
}
